import React,{useState} from 'react';
import {useNavigate} from "react-router-dom"
import 'contents/assets/scss/page/student.scss'
/*component*/
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopClassRequest from "../student/_PopClassRequest";
import PopClassRegister from '../student/_PopClassRegister';

function ClassRegister() {
  const navigate = useNavigate();
  const [modalClassRequest, setModalClassRequest] = useState(false);//배정 요청서
  const [modalClassRegisterOpen, setModalClassRegisterOpen] = useState(false);//수업등록
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"전체", value:0},
    {title:"배정 요청", value:1, type:"new"},
    {title:"승인 요청", value:2},
    {title:"배정 완료", value:3},
    {title:"첫수업", value:4, type:"new"},
  ];
  return (
    <>
    <main className="com_container p_class_register">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu1_3'>수업등록 요청</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus" onClick={() => setModalClassRegisterOpen(true)}>수업 등록</button>
            <button className="com_btn orange s btn_plus">학생 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className='com_board_list__top'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className='com_divider'/>
            <div className='com_board_list__top'>
              <section className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">원격</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">대면</label>
                  <select className='select'>
                    <option>과목 전체</option>
                  </select>
                </div>                
              </section>
              <section className='com_board_search end'>
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <article className="search divider">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력"
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <table className='com_board_list'>
              <colgroup>
                <col width="4%"/><col width="6%" span="4"/>
                <col width="4.5%" span="2"/><col width="6%" span="8"/>
                <col width="3.8%"/><col width="6%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>배정 요청일</th>
                  <th>첫 수업일</th>
                  <th>학생</th>
                  <th>영역</th>
                  <th>수업 방법</th>
                  <th>비고</th>
                  <th>타임/수업시간</th>
                  <th>DC 금액</th>
                  <th>실 수업료</th>
                  <th>지역</th>
                  <th>담임</th>
                  <th>교사</th>
                  <th>배송 소요시간<br/><span className='sub'>(분)</span></th>
                  <th>통보 소요시간<br/><span className='sub'>(분)</span></th>
                  <th>배정요청</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr onClick={() => navigate("/Html/Student/ClassRegister/Detail")}>
                  <td>1</td>
                  <td className='td_date'>2022.08.25 09:00</td>
                  <td className='td_date'>2022.08.25 09:00</td>
                  <td><button className="txt btn_link">가학생103</button></td>
                  <td>국어 외 4종</td>
                  <td>화상</td>
                  <td>인계</td>
                  <td>1T/90분</td>
                  <td>무료</td>
                  <td className='bg_col td_point'>80,000</td>
                  <td className='bg_col'>서울시 서초구 무슨동</td>
                  <td className='bg_col'>-</td>
                  <td className='bg_col'>-</td>
                  <td>전체 : 178<br/>단계 : 45</td>
                  <td>45:00</td>
                  <td>2명</td>
                  <td className='com_red_txt'>배정요청 (인계)</td>
                </tr>
                <tr onClick={() => navigate("/Html/Student/ClassRegister/Detail")}>
                  <td>2</td>
                  <td className='td_date'>2022.08.25 09:00</td>
                  <td className='td_date'>2022.08.25 09:00</td>
                  <td><button className="txt btn_link">가학생103</button></td>
                  <td>국어 외 4종</td>
                  <td>화상</td>
                  <td>인계</td>
                  <td>1T/90분</td>
                  <td><span className="com_red_txt">- 60,000</span></td>
                  <td className='bg_col td_point'>80,000</td>
                  <td className='bg_col'>서울시 서초구 무슨동</td>
                  <td className='bg_col'>-</td>
                  <td className='bg_col'>-</td>
                  <td>전체 : 178<br/>단계 : 45</td>
                  <td>45:00</td>
                  <td>2명</td>
                  <td className='com_green_txt'>배정반려<br/>2021, 08, 30</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx} onClick={() => navigate("/Html/Student/ClassRegister/Detail")}>
                      <td>{idx + 3}</td>
                      <td className='td_date'>2022.08.25 09:00</td>
                      <td className='td_date'>2022.08.25 09:00</td>
                      <td><button className="txt btn_link">가학생103</button></td>
                      <td>국어 외 4종</td>
                      <td>화상</td>
                      <td>인계</td>
                      <td>1T/90분</td>
                      <td><span className="com_red_txt">- 60,000</span></td>
                      <td className='bg_col td_point'>80,000</td>
                      <td className='bg_col'>서울시 서초구 무슨동</td>
                      <td className='bg_col'>-</td>
                      <td className='bg_col'>-</td>
                      <td>전체 : 178<br/>단계 : 45</td>
                      <td>45:00</td>
                      <td>2명</td>
                      <td className='td_point'>승인요청 (인계) <br />2021, 08, 30</td>
                    </tr>
                  )
                })}
                
              </tbody>
            </table>
            <Paging />
          </div>
        </section>
      </div>
    </main>
    {/*수업배정요청 팝업*/}
    <PopClassRequest
      open={modalClassRequest}
      close={() => setModalClassRequest(false)}
    />
    {/*수업 등록 팝업*/}
    <PopClassRegister open={modalClassRegisterOpen} close={() => setModalClassRegisterOpen(false)} />
    </>
  );
}

export default ClassRegister;
